import { Flex, Input, InputGroup, InputLeftAddon, useToast } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { useMutation, useQueryClient } from 'react-query'
import { formatPrice } from '../../../utils/formatPrice'
import { useParams } from 'react-router-dom'
import { api } from '../../../services/api'
import { Button } from '../../../components/Button'
import { useEffect } from 'react'
import { useOrcamentoPedido } from '../../../contexts/OrcamentoPedidoProvider'

async function updatePrecoVenda({ numeroNota, codigoProduto, sequencia, valorUnitario }) {
  const response = await api.put('/site/v2/orcamento-crm/atualiza-preco-venda', {
    numero_nota: numeroNota,
    codigo_produto: codigoProduto,
    sequencia: sequencia,
    valor_unitario: valorUnitario,
  })

  return response.data
}

export function UpdatePrecoVenda({ item }) {
  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true,
  })

  const { numeroProposta: numProposta } = useParams()
  const { pedidoBloqueado } = useOrcamentoPedido()

  const queryClient = useQueryClient()

  const { register, handleSubmit, setValue } = useForm({
    defaultValues: {
      preco_venda: item.original_preco_venda ?? item.preco_venda ?? '',
    },
  })

  useEffect(() => {
    setValue('preco_venda', item.original_preco_venda)
  }, [item.original_preco_venda, setValue])

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: updatePrecoVenda,
    onSuccess: (data) => {
      setValue('preco_venda', parseFloat(data.preco_venda).toFixed(2))
      queryClient.setQueryData(['items', numProposta], (oldData) => {
        const updatedItem = oldData.itens.map((item) => {
          if (item.codigo_produto === data.codigo_produto && item.sequencia === data.sequencia) {
            return {
              ...item,
              preco_site: formatPrice(data.preco_site),
              original_preco_venda: data.preco_venda,
              valor_unitario: data.valor_unitario,
              preco_base: formatPrice(data.preco_base),
              valor_total_itens: formatPrice(data.valor_total_itens),
              original_valor_total_itens: data.valor_total_itens,
              vlr_substituicao: formatPrice(data.vlr_substituicao),
              original_vlr_substituicao: data.vlr_substituicao,
              preco_venda: formatPrice(data.preco_venda),
            }
          }

          return item
        })

        return {
          ...oldData,
          informacao_da_proposta: {
            ...oldData.informacao_da_proposta,
            comissao_prevista: data.comissao_prevista,
          },
          itens: updatedItem,
        }
      })

      toast({
        title: data.message,
        description: `Preço de venda atualizado para ${formatPrice(data.valor_unitario)}`,
        status: 'success',
      })
    },
    onError: (error) => {
      if (error instanceof z.ZodError) {
        toast({
          title: 'Erro ao atualizar o preço de venda',
          description: 'O preço de venda deve ser um valor válido',
          status: 'error',
        })
      }

      toast({
        title: 'Erro ao atualizar o preço de venda',
        description: error.response.data.erros,
        status: 'error',
      })
    },
  })

  async function handleUpdatePrecoVenda(data) {
    const schemaToUpdatePrecoVenda = z.object({
      preco_venda: z.string().nonempty(),
    })

    try {
      const { preco_venda } = schemaToUpdatePrecoVenda.parse(data)

      await mutateAsync({
        numeroNota: item.numero_nota,
        codigoProduto: item.codigo_produto,
        sequencia: item.sequencia,
        valorUnitario: preco_venda,
      })
    } catch (error) {
      toast({
        title: 'Erro ao atualizar o preço de venda',
        description: 'O preço de venda deve ser um valor válido',
        status: 'error',
      })
    }
  }

  return (
    <Flex alignItems="center" w="100%" as="form" onSubmit={handleSubmit(handleUpdatePrecoVenda)} pointerEvents={!pedidoBloqueado && 'all'}>
      <InputGroup>
        <InputLeftAddon children="Preço venda" fontSize="12px" h="29px" bgColor="#f5f5f5" borderRadius="0" borderColor="#CFCFCF" />
        <Input
          borderRadius={0}
          borderColor="#CFCFCF"
          h="29px"
          {...register('preco_venda')}
          size="sm"
          placeholder="Digite o preço venda"
          w="100%"
          isDisabled={isLoading}
        />
      </InputGroup>

      <Button bgColor="#0075B1" type="submit" isLoading={isLoading} h="29px" borderRadius="0">
        Atualizar
      </Button>
    </Flex>
  )
}
